/**
 * 复盘覆盖度统计：双方必打论据命中率与未打清单。
 */
import { SIDES, sideLabel, type MotionPackage } from '@zongheng/core-schema';
import { useArena } from '../../state/ArenaContext.tsx';
import { Badge, EmptyState, cx } from '../ui/primitives.tsx';
import { buildEvidenceCoverage } from '../../export/report.ts';

export function CoverageSummary({ motion }: { motion: MotionPackage }) {
  const { state } = useArena();
  const coverage = buildEvidenceCoverage(motion, state.manualEvidenceChecks);
  const totalRequired = coverage.AFF.requiredCount + coverage.NEG.requiredCount;
  const totalHit = coverage.AFF.hitCount + coverage.NEG.hitCount;

  return (
    <section
      className="rounded-xl border border-white/10 bg-bg-surface/80 backdrop-blur"
      data-testid="coverage-summary"
    >
      <header className="flex items-start justify-between gap-2 border-b border-white/5 px-4 py-3">
        <div>
          <h2 className="text-sm font-semibold tracking-wide text-slate-100">必打论据覆盖度统计</h2>
          <p className="mt-0.5 text-xs text-slate-400">
            合计 {totalHit} / {totalRequired} 条 · 分母为题库卡片必打论据去重合集
          </p>
        </div>
        <Badge tone={totalRequired === 0 ? 'neutral' : totalHit === totalRequired ? 'pass' : 'warning'}>
          {totalRequired === 0 ? '无配置' : `${Math.round((totalHit / totalRequired) * 100)}%`}
        </Badge>
      </header>
      <div className="space-y-2 p-3">
        {totalRequired === 0 ? (
          <EmptyState title="题库未配置必打论据" />
        ) : (
          SIDES.map((side) => {
            const sideCoverage = coverage[side];
            return (
              <div key={side} className="rounded-lg border border-white/10 bg-black/20 p-2.5">
                <div className="flex items-center justify-between">
                  <Badge tone={side === 'AFF' ? 'aff' : 'neg'}>{sideLabel(side)}</Badge>
                  <span className="mono text-xs text-slate-300">
                    {sideCoverage.hitCount} / {sideCoverage.requiredCount}（{sideCoverage.percent}%）
                  </span>
                </div>
                <div className="mt-1.5 h-1 overflow-hidden rounded-full bg-black/40">
                  <div
                    className={cx('h-full rounded-full', side === 'AFF' ? 'bg-team-aff' : 'bg-team-neg')}
                    style={{ width: `${sideCoverage.percent}%` }}
                  />
                </div>
                {sideCoverage.missing.length > 0 ? (
                  <p className="mt-1.5 text-[11px] text-slate-500">
                    未打：{sideCoverage.missing.map((item) => item.shortTitle).join('；')}
                  </p>
                ) : (
                  <p className="mt-1.5 text-[11px] text-assert-pass">全部必打论据已勾选。</p>
                )}
              </div>
            );
          })
        )}
      </div>
    </section>
  );
}
